import React, { useContext, useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { CloseMainDropdownContext } from '../../../context/basicContexts';
import { useNavbarContext } from '../../../context/NavbarContext';
import useResponsive from '../../../hooks/useResponsive';

const isExternalLink = (url, currentHost = typeof window !== 'undefined' ? window.location.host : '') => {
  if (!url || typeof url !== 'string') {
    return false; // Nieprawidłowy lub pusty URL
  }

  // Podczas SSR nie sprawdzamy linków zewnętrznych
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const parsedUrl = new URL(url, window.location.origin); // Używa bieżącego origin jako bazy
    return parsedUrl.host !== currentHost;
  } catch (e) {
    return false; // Nieprawidłowy URL nie jest linkiem zewnętrznym
  }
};

const extractPath = url => {
  try {
    const currentUrl = new URL(url);
    return currentUrl.pathname.substring(1);
  } catch (e) {
    return url;
  }
};

const generateLink = (beautified_url, item_type, type) => {
  if (type === 'row' || type === 'column') return;

  let outputLink = beautified_url;
  
  // Obsługa pustego, undefined lub null URL
  if (!beautified_url || beautified_url === '' || beautified_url === null || beautified_url === undefined) {
    return '/';
  }
  if (item_type !== 'custom' && item_type !== 'page') {
    return outputLink;
  }

  switch (item_type) {
    case 'custom':
      if (outputLink.charAt(outputLink.length - 1) === '/') {
        outputLink = outputLink.slice(0, -1);
      }
      if (outputLink.charAt(0) === '/') {
        outputLink = outputLink.substring(1);
      }
      if (isExternalLink(beautified_url)) {
        outputLink = `/${outputLink}`;
      }
      break;

    case 'page':
      outputLink = extractPath(outputLink);
      break;

    default:
      break;
  }

  return outputLink;
};

const MenuNavbarLink = ({ children, className, url, item_type, type, setShowDropdown, parent }) => {
  const { isMobile } = useResponsive();
  const generatedLink = useMemo(() => generateLink(url, item_type, type), [url, item_type, type]);
  const { setIsMenuExpanded } = useNavbarContext();
  const closeMainDropdown = useContext(CloseMainDropdownContext);

  // Obsługa pustego URL - element nieaktywny (tylko dropdown)
  if (generatedLink === '/' || !generatedLink) {
    return (
        <span
            className={`${className} navbar-link--disabled`}
            role="button"
            tabIndex={0}
            style={{ cursor: setShowDropdown ? 'pointer' : 'default' }}
            onClick={e => {
              if (setShowDropdown) {
                setShowDropdown(last => !last);
              }
              e.preventDefault();
            }}
            onKeyDown={e => {
              if ((e.key === 'Enter' || e.key === ' ') && setShowDropdown) {
                setShowDropdown(last => !last);
                e.preventDefault();
              }
            }}
        >
          {children}
        </span>
    );
  }
  return (
      <NavLink
          className={({ isActive }) => {
            const baseClass = className || '';
            // const activeClass = isActive && parent ? (!isMobile ? 'active-parent' : 'active-parent__mobile') : '';
            const activeClass = isActive && parent ? 'active-parent' : '';
            return `${baseClass} ${activeClass}`.trim();
          }}
          style={{}}
          to={generatedLink ? `/${generatedLink}` : '/'}
          aria-current={undefined}
          onClick={() => {
            setIsMenuExpanded(false);
            closeMainDropdown();
          }}
      >
        {children}
      </NavLink>
  );
};

export default MenuNavbarLink;